export default ({ app: { router }, store }) => {
  /* 每次路由变更时进行pv统计 */
  router.afterEach((to, from) => {
    /* 告诉增加一个PV */
    try {
      window._hmt = window._hmt || []
      window._hmt.push(['_trackPageview', to.fullPath])
      console.log('统计')
    } catch (e) {
    }
  })
}



// WEBPACK FOOTER //
// ./plugins/baidu.js